<template>
  <div @click="clickMarker" ref="sceneMaterialImage"
       :style="{'z-index':this.imageInfo.showSet.showTop ? 1 : 0,'display':this.imageInfo.showSet.totalVisible ? 'block' : 'none',
       'animation-name':animationName,'animation-duration':animationDuration+'s'}"
       class="sceneMaterialImage alibabaPuHuiTiFontFamily">
    <img :style="{'animation-name':animationImageName,'animation-duration':animationDuration+'s'}" :class="animationClass"
         :src="imageInfo.geoJson.geo.properties.thumbUrl" style="max-width:200px;max-height:200px;animation-fill-mode:forwards;">
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";

export default {
  name: "SceneMaterialImage",
  props:["imageInfo"],
  data() {
    return {
      marker: '',

      markerShowAnimationBeginSeconds:0,   //开始时的秒数  ms
      markerShowSeconds:0,   //持续的秒数  ms
      markerHideAnimationEndSeconds:0,   //隐藏动画结束时的秒数  ms
      //绑定在整体的动画
      animationName:"",
      animationDuration:"1",
      //绑定图片的动画
      animationImageName:"",
      animationClass:"",

      animationShowTemp:"",    //监听开始出现
      animationingTemp:"",    //监听动画过程中
      animationing:false,
      animationHideTemp:"",    //监听开始隐藏
      animationFinishTemp:"",    //监听结束延时


    }
  },
  computed: {
    //监听变量深拷贝，解决深度监听时新值和旧值相同的问题
    imageInfo_computed() {
      return JSON.parse(JSON.stringify(this.imageInfo))
    },
  },
  watch:{
    imageInfo_computed:{
      handler(newVal, oldVal) {
        if((newVal.geoJson.geo.geometry.coordinates[0] !== oldVal.geoJson.geo.geometry.coordinates[0])
            || (newVal.geoJson.geo.geometry.coordinates[1] !== oldVal.geoJson.geo.geometry.coordinates[1])){
          //图标位置变化。重新定位
          this.marker.setLngLat(this.imageInfo.geoJson.geo.geometry.coordinates)
        }
      },
      deep: true
    }
  },
  methods:{
    clickMarker(){
      this.$emit("clickMarker",this.imageInfo)
    },

    //根据点信息和当前录制点，获取点显示秒数(只有播放和预览时需要)
    getShowSeconds(){
      // console.log(this.$store.state.sceneCurrPlayItem)

      if(this.$store.state.sceneCurrPlayItem.viewPointList.length === 1){

        //单点录制点，考虑动效有进场和离场，showSet的timeRange可以是[0,0]或[0,1]
        if(this.imageInfo.showSet.timeRange[0] === 0){
          //素材的开始动画前秒数为进场动画秒数
          //素材的显示秒数即录制点动效持续时间（加延时时间？）- 进场动画秒数
          //素材动效结束秒数，当素材动效结束点在最后一个视野点时，即录制点动效持续时间（加延时时间？）- 离场动画秒数；当素材动效结束点在“结束”时，即录制点动效持续时间（加延时时间？）
          switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
            case "螺旋凝视":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.timeout) * 1000
              break;
            }
            case "太空俯冲":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.timeout) * 1000
              break;
            }
            case "地球自转":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.timeout) * 1000
              break;
            }
            case "高空悬停":{
              //进场动效1秒
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.timeout * 1000 + 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.timeout) * 1000
              break;
            }
            case "螺旋环绕":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout) * 1000
              break;
            }
            case "螺旋靠近":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout) * 1000
              break;
            }
            case "俯冲环绕":{
              //进场动效5秒
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.timeout * 1000 + 5000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.timeout) * 1000
              break;
            }
            case "俯冲观测":{
              //进场动效800毫秒，离场动效800毫秒
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout * 1000 + 800;
              if(this.imageInfo.showSet.timeRange[1] === 1){
                //素材动效在“结束”点位停止
                this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout) * 1000
              }
              else{
                //素材动效在视野点位停止，需要去除离场时间
                this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout) * 1000 - 800
              }
              break;
            }
          }
          this.markerShowSeconds = this.markerHideAnimationEndSeconds - this.markerShowAnimationBeginSeconds;

        }
      }
      else{
        //多录制点
        if(this.imageInfo.showSet.timeRange[0] !== this.imageInfo.showSet.timeRange[1]){
          //有显示时间
          if(this.imageInfo.showSet.timeRange[0] === this.$store.state.sceneCurrPlayItem.viewPointList.length-1
              && this.imageInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
            //时间范围是最后一个视野点开始到结束，平移跟踪效果中最后一个视野点没有时间，所以等于没有显示时间

          }
          else{
            //有正常显示范围
            console.log(this.imageInfo.showSet.timeRange)


            //路线动画总时长 无进场离场的动效即为设置的时间
            let routeDuration;
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.duration * 1000;
                break;
              }
              case "侧向跟踪":{
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.duration * 1000;
                break;
              }
              case "空中游览":{
                //该动效开头有2秒调整zoom，所有点位结束后有3秒延时
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.duration * 1000 - 5000;
                break;
              }
              case "模拟驾驶":{
                //该动效开头有2秒调整zoom，所有点位结束后有3秒延时
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.duration * 1000 - 5000;
                break;
              }

            }
            //总路线长度
            let routePoints = [];
            for(let i=0;i<this.$store.state.sceneCurrPlayItem.viewPointList.length;i++){
              routePoints.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
            }
            let routeDistance = turf.lineDistance(turf.lineString(routePoints));

            //开始动画视野点距初始点的长度
            if(this.imageInfo.showSet.timeRange[0] !== 0){
              let routePointsBeginAnimation = [];
              for(let i=0;i<=this.imageInfo.showSet.timeRange[0];i++){
                routePointsBeginAnimation.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
              }
              let routeDistanceBeginAnimation = turf.lineDistance(turf.lineString(routePointsBeginAnimation));
              //根据比例计算 路线进行到开始动画视野点的时长，即开始动画前的秒数
              this.markerShowAnimationBeginSeconds = routeDistanceBeginAnimation / routeDistance * routeDuration;

              switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                case "空中游览":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds + 2000;
                  break;
                }
                case "模拟驾驶":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds + 2000;
                  break;
                }
              }

              console.log("开始动画前秒数"+this.markerShowAnimationBeginSeconds)
            }
            else{
              //开始动画在0秒就开始
              switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                case "空中游览":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = 2000;
                  break;
                }
                case "模拟驾驶":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = 2000;
                  break;
                }
              }
            }

            //开始时间前需要加上延时
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.timeout * 1000
                break;
              }
              case "侧向跟踪":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.timeout * 1000
                break;
              }
              case "空中游览":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.timeout * 1000
                break;
              }
              case "模拟驾驶":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout * 1000
                break;
              }

            }

            //结束动画视野点距初始点的长度
            let routePointsEndAnimation = [];
            let routePointsEndAnimationNum;
            if(this.imageInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
              //在 结束 点
              routePointsEndAnimationNum = this.imageInfo.showSet.timeRange[1]-1
            }
            // else if(this.imageInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
            //   //在 最后一个视野点
            //   routePointsEndAnimationNum = this.imageInfo.showSet.timeRange[1]-1
            // }
            else{
              routePointsEndAnimationNum = this.imageInfo.showSet.timeRange[1]
            }
            for(let i=0;i<=routePointsEndAnimationNum;i++){
              routePointsEndAnimation.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
            }
            let routeDistanceEndAnimation = turf.lineDistance(turf.lineString(routePointsEndAnimation));
            //根据比例计算 路线进行到结束动画视野点的时长，即结束动画结束时的秒数
            this.markerHideAnimationEndSeconds = routeDistanceEndAnimation / routeDistance * routeDuration;


            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "空中游览":{
                //该动效开头有2秒延时，最后一个视野点到结束有3秒离场
                if(this.imageInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                  //动效显示时间段截止到结束点，需要在最后一个视野点的时间基础上增加开场延时+离场时间
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 5000;
                }
                else{
                  //动效显示时间段截止到某视野点，需要在最后一个视野点的时间基础上增加开场延时
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 2000;
                }

                break;
              }
              case "模拟驾驶":{
                //该动效开头有2秒延时，最后一个视野点到结束有3秒离场
                if(this.imageInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                  //动效显示时间段截止到结束点，需要在最后一个视野点的时间基础上增加开场延时+离场时间
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 5000;
                }
                else{
                  //动效显示时间段截止到某视野点，需要在最后一个视野点的时间基础上增加开场延时
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 2000;
                }

                break;
              }
            }

            //结束时间前需要加上延时
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.timeout * 1000
                break;
              }
              case "侧向跟踪":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.timeout * 1000
                break;
              }
              case "空中游览":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.timeout * 1000
                break;
              }
              case "模拟驾驶":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout * 1000
                break;
              }

            }

            console.log("结束动画结束的秒数"+this.markerHideAnimationEndSeconds)
            //素材显示时间
            this.markerShowSeconds = this.markerHideAnimationEndSeconds - this.markerShowAnimationBeginSeconds


          }


        }



      }

    },
    //开始显隐动画
    beginAnimation(){

      //监听开始动画前的秒数
      clearTimeout(this.animationShowTemp)
      this.animationShowTemp = setTimeout(()=>{
        console.log("开始显示动画")
        this.$refs.sceneMaterialImage.style.display = "block";
        //开始动画
        if(this.imageInfo.showSet.materialShowAnimation !== "无"){
          switch(this.imageInfo.showSet.materialShowAnimation){
            case "无":{

              break;
            }
            case "淡出":{
              this.animationName = "opacity0To1_image"
              break;
            }
            case "浮入":{
              this.animationName = "materialPointHeight0ToAll_image"
              break;
            }
            case "扩展":{
              this.$refs.sceneMaterialImage.style.width = "200px"
              this.$refs.sceneMaterialImage.style.height = "200px"
              this.animationClass = "centerToAllClass_image"

              this.animationImageName = "centerToAll_image"
              break;
            }
            case "翻跳":{
              this.$refs.sceneMaterialImage.style.width = "200px"
              this.$refs.sceneMaterialImage.style.height = "200px"

              this.animationImageName = "centerToAll_image"
              break;
            }

          }
          this.animationing = true;
          //监听动画结束，显示标题
          clearTimeout(this.animationingTemp)
          this.animationingTemp = setTimeout(()=>{
            this.animationing = false;

            //显示动画结束，开始监听消失动画
            //有消失动画，监听显示秒数（总显示时间-显示动画时间-消失动画时间）等待消失动画开始，进行隐藏动画
            //无消失动画，显示秒数（总显示时间-显示动画时间）
            if(this.imageInfo.showSet.materialHideAnimation !== "无"){
              clearTimeout(this.animationHideTemp)
              this.animationHideTemp = setTimeout(()=>{
                console.log("开始隐藏")

                //隐藏动画名称
                switch(this.imageInfo.showSet.materialHideAnimation){
                  case "无":{

                    break;
                  }
                  case "淡出":{
                    this.animationName = "opacity1To0_image"
                    break;
                  }
                  case "浮入":{
                    this.animationName = "materialPointHeightAllTo0_image"
                    break;
                  }
                  case "扩展":{
                    this.animationImageName = "allToCenter_image"
                    break;
                  }
                  case "翻跳":{
                    this.animationImageName = "allToCenter_image"
                    break;
                  }

                }

                this.animationing = true;
                //监听隐藏动画结束，显示标题
                clearTimeout(this.animationingTemp)
                this.animationingTemp = setTimeout(()=>{
                  this.animationing = false;
                  this.$refs.sceneMaterialImage.style.display = "none";
                },this.animationDuration * 1000)
              },this.markerShowSeconds - this.animationDuration * 1000 - this.animationDuration * 1000)

            }
            else{
              //无消失动画
              clearTimeout(this.animationHideTemp)
              this.animationHideTemp = setTimeout(()=>{
                //无动画，直接消失
                this.$refs.sceneMaterialImage.style.display = "none";
              },this.markerShowSeconds - this.animationDuration * 1000)
            }

          },this.animationDuration * 1000)
        }
        else{
          //无开始动画，直接监听消失动画
          //有消失动画，监听显示秒数（总显示时间-消失动画时间）等待消失动画开始，进行隐藏动画
          //无消失动画，显示秒数（总显示时间）
          if(this.imageInfo.showSet.materialHideAnimation !== "无"){
            clearTimeout(this.animationHideTemp)
            this.animationHideTemp = setTimeout(()=>{
              console.log("开始隐藏")

              //隐藏动画
              switch(this.imageInfo.showSet.materialHideAnimation){
                case "无":{

                  break;
                }
                case "淡出":{
                  this.animationName = "opacity1To0"
                  break;
                }
                case "浮入":{
                  this.animationName = "materialPointHeightAllTo0"
                  break;
                }
                case "扩展":{
                  this.animationImageName = "allToCenter"
                  break;
                }
                case "翻跳":{
                  this.animationImageName = "allToCenter"
                  break;
                }

              }

              this.animationing = true;
              //监听隐藏动画结束，显示标题
              clearTimeout(this.animationingTemp)
              this.animationingTemp = setTimeout(()=>{
                this.animationing = false;
                this.$refs.sceneMaterialPoint.style.display = "none";
              },this.animationDuration * 1000)

            },this.markerShowSeconds - this.animationDuration * 1000)

          }
          else{
            //无消失动画
            clearTimeout(this.animationHideTemp)
            this.animationHideTemp = setTimeout(()=>{
              //无动画，直接消失
              this.$refs.sceneMaterialImage.style.display = "none";
            },this.markerShowSeconds)
          }

        }
      },this.markerShowAnimationBeginSeconds)


      //监听结束动画结束的秒数，到达时清空所有监听
      clearTimeout()
      this.animationFinishTemp = setTimeout(()=>{
        this.animationing = false;
        this.$refs.sceneMaterialImage.style.display = "none";
        clearTimeout(this.animationShowTemp)
        clearTimeout(this.animationingTemp)
        clearTimeout(this.animationHideTemp)

      },this.markerHideAnimationEndSeconds)




    }
  },
  mounted() {
    console.log(this.imageInfo)

    //当前正在播放或预览，需要考虑动画
    if(this.$store.state.sceneCurrPlayItem !== ""){
      if(this.imageInfo.showSet.allShowInScenePoint){
        //在项目中常显，不做动画操作


      }
      else{
        this.getShowSeconds()

        //有显示时间
        if(this.markerShowSeconds !== 0){
          //先设为隐藏，等动画时间出现
          this.$refs.sceneMaterialImage.style.display = "none";
          //标记显隐动画
          this.beginAnimation()
        }
        else{
          //没有显示时间，不显示点
          this.$refs.sceneMaterialImage.style.display = "none";
        }

      }

    }
    else{
      //没有动画
    }

    this.marker = new mapboxgl.Marker(this.$refs.sceneMaterialImage,{
      anchor:"bottom",
      offset:[0,-10]
    }).setLngLat(this.imageInfo.geoJson.geo.geometry.coordinates)
        .addTo(this.$parent.$parent.map)

  },
  destroyed() {
    clearTimeout(this.animationShowTemp)
    clearTimeout(this.animationingTemp)
    clearTimeout(this.animationHideTemp)
    clearTimeout(this.animationFinishTemp)
    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.sceneMaterialImage{
  position:absolute;
  /*width:200px;*/
  /*height:200px;*/
  cursor:pointer;
  overflow:hidden;
  animation-fill-mode:forwards;
}



</style>


<style>
/*各种标记动效*/

/*从地面出现*/
@keyframes materialPointHeight0ToAll_image {
  from {height:0;}
  to {height:200px;}   /*css变量，标记应设的高度，在js中赋值*/
}
/*进入地面隐藏*/
@keyframes materialPointHeightAllTo0_image {
  from {height:200px;}
  to {height:0;}
}

/*从侧面出现*/
@keyframes materialPointWidth0ToAll_image {
  from {width:0;}
  to {width:200px;}
}
/*从侧面隐藏*/
@keyframes materialPointWidthAllTo0_image {
  from {width:200px;}
  to {width:0;}
}


/*透明度*/
@keyframes opacity0To1_image {
  from {opacity:0;}
  to {opacity:1;}
}
@keyframes opacity1To0_image {
  from {opacity:1;}
  to {opacity:0;}
}


/*绑定在img，弹跳*/
@keyframes centerToAll_image {
  from {width:0;height:0;}
  to {width:200px;height:200px;}
}
@keyframes allToCenter_image {
  from {width:200px;height:200px;}
  to {width:0;height:0;}
}

/*绑定在img，结合上面的跳出，实现从中间到四周出现*/
.centerToAllClass_image{
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}



</style>